var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.users.total!==0)?_c('div',{staticClass:"pagination-wrap"},[_c('PaginationNavigation')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }